import surveyService from "../../services/surveyService";
import { getField, updateField } from "vuex-map-fields";

const state = {
  surveys: [],
  filteredSurveys: [],
  selectedSurvey: null,
  selectedSurveyNumber: -1, // replace this at some point
  selectedSurveyNumberForExhibits: -1, // replace this at some point
  viewedVirtualMeeting: false
};

const getters = {
  getField,
  surveys: state => {
    return state.surveys;
  }
};

const actions = {
  async fetchSurveys({ commit }) {
    let surveys = await surveyService.fetchData()
    commit("UPDATE_SURVEYS", surveys);
    return surveys
  },
  updateSurvey({ commit }, payload) {
    surveyService.updateSurvey(payload).then(survey => {
      commit("UPDATE_SURVEY", survey)
    })
  },
  updateSelectedSurvey({ commit }, survey) {
    commit("UPDATE_SELECTED_SURVEY", survey);
    commit("UPDATE_SELECTED_SURVEY_NUMBER", survey.pk);
  },
  filterSurveys({ commit }, filteredSurveys) {
    commit("FILTER_SURVEYS", filteredSurveys);
  },
  updateSelectedSurveyNumber({ commit }, surveyNumber) {
    commit("UPDATE_SELECTED_SURVEY_NUMBER", surveyNumber);
  },
  updateSelectedSurveyNumberForExhibits({ commit }, surveyNumber) {
    commit("UPDATE_SELECTED_SURVEY_NUMBER_FOR_EXHIBITS", surveyNumber);
  },
  toggleVirtualMeetingBoolean({ commit }, boolean) {
    commit("TOGGLE_VIRTUAL_MEETING_BOOLEAN", boolean)
  }
};

const mutations = {
  updateField,
  UPDATE_SURVEYS(state, surveyData) {
    state.surveys = surveyData;
  },
  UPDATE_SELECTED_SURVEY(state, selectedSurvey) {
    state.selectedSurvey = selectedSurvey;
  },
  FILTER_SURVEYS(state, filteredSurveys) {
    state.filteredSurveys = filteredSurveys;
  },
  UPDATE_SELECTED_SURVEY_NUMBER(state, surveyNumber) {
    state.selectedSurveyNumber = surveyNumber;
  },
  UPDATE_SELECTED_SURVEY_NUMBER_FOR_EXHIBITS(state, surveyNumber) {
    state.selectedSurveyNumberForExhibits = surveyNumber;
  },
  UPDATE_SURVEY(state, survey) {
    let surveyIndex = state.surveys.findIndex(surveyInState => surveyInState.pk === survey.pk)
    state.surveys[surveyIndex].name = survey.name;
    state.surveys[surveyIndex].locked = survey.locked;
    state.surveys[surveyIndex].project = survey.project;
    state.surveys[surveyIndex].survey_metadata = survey.survey_metadata;
    state.surveys[surveyIndex].survey_json = survey.survey_json;
    state.surveys[surveyIndex].view_in_list = survey.view_in_list;
  },
  TOGGLE_VIRTUAL_MEETING_BOOLEAN(state, boolean) {
    state.viewedVirtualMeeting = boolean
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};